import API from '../../api';

const ROOT = '/v1/combat-pro/provenance';

export async function openSpecialistSource(slug) {
  return (await API.post(ROOT + '/sources/' + encodeURIComponent(slug) + '/open')).data;
}

export async function fetchContextualGeneratorCatalogue(context, campaignId, browseAll) {
  const params = new URLSearchParams();
  params.set('context', context);
  if (campaignId) params.set('campaign_id', campaignId);
  if (browseAll) params.set('browse', '1');
  return (await API.get(ROOT + '/catalogue?' + params.toString())).data;
}

export async function fetchSavedGeneratorResults(campaignId, slug) {
  const params = new URLSearchParams({ campaign_id: campaignId, source_generator_slug: slug });
  return (await API.get(ROOT + '/results?' + params.toString())).data;
}

export async function shareSavedGeneratorResult(resultId, payload) {
  return (await API.post(ROOT + '/results/' + encodeURIComponent(resultId) + '/share', payload)).data;
}

export async function ingestStructuredResult(payload) {
  return (await API.post(ROOT + '/results', payload)).data;
}

export async function contextualizeInventoryItem(itemId, payload) {
  return (await API.post(ROOT + '/items/' + encodeURIComponent(itemId) + '/contextualize', payload)).data;
}

export async function revealInventoryProperty(itemId, payload) {
  return (await API.post(ROOT + '/items/' + encodeURIComponent(itemId) + '/reveal', payload)).data;
}

export async function craftInventoryItem(payload) {
  return (await API.post(ROOT + '/craft', payload)).data;
}

export async function createItemCommission(payload) {
  return (await API.post(ROOT + '/commissions', payload)).data;
}

export async function completeItemCommission(commissionId, payload) {
  return (await API.post(ROOT + '/commissions/' + encodeURIComponent(commissionId) + '/complete', payload)).data;
}
